import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { navigateWithFrom } from '../utils/navigationUtils';
import { getOnemBorderClass, getPriorityToken } from '../utils/onemDerecesiHelper';

const getStatusToken = (durum = '') => {
  const value = String(durum || '').toLowerCase();
  if (value.includes('sipariş') || value.includes('siparis')) return 'siparis';
  if (value.includes('devam')) return 'progress';
  if (value.includes('tamam') || value.includes('bitti')) return 'done';
  if (value.includes('iptal')) return 'cancel';
  return 'new';
};

const ServisKaydiBaglantiKart = ({ servisKaydiId, serviceRecord }) => {
  const navigate = useNavigate();
  const location = useLocation();

  if (!servisKaydiId) return null;

  const sk = serviceRecord || {};
  const customer = sk.musteri || {};
  const customerName =
    `${customer.adi || customer.name || ''} ${customer.soyadi || customer.surname || ''}`.trim() || '—';
  const customerPhone = customer.telefon || customer.phone || '—';
  const numara = sk.numara || '—';
  const priorityToken = getPriorityToken(sk.onemDerecesi);
  const onemBorderClass = getOnemBorderClass(sk.onemDerecesi);
  const statusToken = getStatusToken(sk.durum);

  const goToServiceRecord = () => {
    navigateWithFrom(navigate, `/service-records/${servisKaydiId}/update`, location);
  };

  return (
    <div className="randevu-bilgi-servis-kaydi">
      <span className="randevu-bilgi-servis-kaydi__title">Bağlı Servis Kaydı</span>
      <button type="button" className={`servis-kaydi-baglanti-kart${onemBorderClass ? ` ${onemBorderClass}` : ''}`} onClick={goToServiceRecord}>
        <div className="servis-kaydi-baglanti-kart__row">
          <div className="servis-kaydi-baglanti-kart__item">
            <span className="servis-kaydi-baglanti-kart__label">Servis No</span>
            <span className="servis-kaydi-baglanti-kart__value servis-kaydi-baglanti-kart__value--numara">
              {numara}
            </span>
          </div>
          <div className="servis-kaydi-baglanti-kart__item">
            <span className="servis-kaydi-baglanti-kart__label">Müşteri</span>
            <span className="servis-kaydi-baglanti-kart__value">{customerName}</span>
            <span className="servis-kaydi-baglanti-kart__meta">Telefon: {customerPhone}</span>
          </div>
          <div className="servis-kaydi-baglanti-kart__item">
            <span className="servis-kaydi-baglanti-kart__label">İşlem Tipi</span>
            <span className="servis-kaydi-baglanti-kart__value">{sk.islemTipi || '—'}</span>
          </div>
          <div className="servis-kaydi-baglanti-kart__item">
            <span className="servis-kaydi-baglanti-kart__label">Önem</span>
            <span className={`priority-badge priority-${priorityToken}`}>{sk.onemDerecesi || '—'}</span>
          </div>
          <div className="servis-kaydi-baglanti-kart__item">
            <span className="servis-kaydi-baglanti-kart__label">Durum</span>
            <span className={`status-chip status-${statusToken}`}>{sk.durum || '—'}</span>
          </div>
        </div>
        <span className="servis-kaydi-baglanti-kart__cta">
          <i className="fas fa-arrow-right" aria-hidden />
        </span>
      </button>
    </div>
  );
};

export default ServisKaydiBaglantiKart;
